import axios from 'axios'
import { Message } from 'view-design'
import {getCookies,removeCookies,getLoginEntryPath,redirectToLoginEntry,markWecomLogin,clearWecomLogin} from '@/utils/helper'
import config from '@/config';

/** 延迟取 router，避免与 layout/api 形成循环依赖 */
function getAppRouter() {
    return require('@/router').default
}

const service = axios.create({
    baseURL: config.apiUrl,
    timeout: 100000 // 请求超时时间
})

service.interceptors.request.use(
    config => {
        const token = getCookies('token')
        if (token) {
            config.headers['Authori-zation'] = token
        }
        return config
    },
    error => {
        // do something with request error
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        let status = response.data ? response.data.status : 0
        const code = status
        switch (code) {
            case 200:
                return response.data
            case 400:
                return Promise.reject( response.data || { msg: '未知错误' })
            case 400011:
            case 500:
            case 400012:
                return Promise.reject( { msg: '系统异常' })
            case 410000:
            case 410001:
            case 410002:
                {
                    const router = getAppRouter()
                    const fromWecom = getLoginEntryPath() === '/admin/login/wecom'
                    localStorage.clear()
                    removeCookies('token')
                    removeCookies('expires_time')
                    removeCookies('uuid')
                    if (fromWecom) {
                        markWecomLogin()
                        redirectToLoginEntry(router, '/admin/login/wecom')
                    } else {
                        clearWecomLogin()
                        router.replace({ path: '/' })
                    }
                }
                break
            default:
                break
        }
    },
    error=>{
        if (typeof error.response == "undefined") {
            Message.error("服务器异常");
        }
        return Promise.reject(error);
    }
)

export default service;
